import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RootMaterialModule } from 'src/app/shared/modules/root-material.module';
import { MatCardModule } from '@angular/material/card';
import { DashboardComponent } from './dashboard.component';
import { RouterModule } from '@angular/router';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { DashboardClientComponent } from './dashboard-client/dashboard-client.component';
import { AppModule } from '../../app.module';
const routes = [{ path: '', component: DashboardComponent }];

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardAdminComponent,
    DashboardClientComponent,
  ],
  imports: [CommonModule, RootMaterialModule, RouterModule.forChild(routes)],
})
export class DashboardModule {}
